import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Text = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.secondary.labels};
  padding: 5px 15px 0;
  text-align: center;

  a {
    text-decoration: underline;
  }
`;
